
import { Platform } from "@/types/profile";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface PlatformIconsProps {
  platforms?: Platform[] | null;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export const PlatformIcons = ({ platforms, size = "md", className }: PlatformIconsProps) => {
  const safePlatforms = (Array.isArray(platforms) ? platforms : [])
    .filter((platform): platform is Platform => typeof platform === "string")
    .map(platform => platform.toLowerCase() as Platform);
  const tagSize = {
    sm: "text-xs px-1",
    md: "text-xs px-1.5 py-0.5",
    lg: "text-sm px-2 py-0.5",
  };

  return (
    <TooltipProvider>
      <div className={cn("flex flex-wrap gap-1", className)}>
        {safePlatforms.includes("macos") && (
          <Tooltip>
            <TooltipTrigger asChild>
              <span className={cn(
                "inline-flex items-center justify-center bg-gray-100 text-gray-800 rounded",
                tagSize[size]
              )}>
                macOS
              </span>
            </TooltipTrigger>
            <TooltipContent>
              <p>macOS</p>
            </TooltipContent>
          </Tooltip>
        )}
        
        {safePlatforms.includes("ios") && (
          <Tooltip>
            <TooltipTrigger asChild>
              <span className={cn(
                "inline-flex items-center justify-center bg-info/10 text-info rounded",
                tagSize[size]
              )}>
                iOS
              </span>
            </TooltipTrigger>
            <TooltipContent>
              <p>iOS</p>
            </TooltipContent>
          </Tooltip>
        )}
        
        {safePlatforms.includes("ipados") && (
          <Tooltip>
            <TooltipTrigger asChild>
              <span className={cn(
                "inline-flex items-center justify-center bg-purple-100 text-purple-800 rounded",
                tagSize[size]
              )}>
                iPad
              </span>
            </TooltipTrigger>
            <TooltipContent>
              <p>iPadOS</p>
            </TooltipContent>
          </Tooltip>
        )}
        
        {safePlatforms.includes("tvos") && (
          <Tooltip>
            <TooltipTrigger asChild>
              <span className={cn(
                "inline-flex items-center justify-center bg-success/10 text-success rounded",
                tagSize[size]
              )}>
                tvOS
              </span>
            </TooltipTrigger>
            <TooltipContent>
              <p>tvOS</p>
            </TooltipContent>
          </Tooltip>
        )}
      </div>
    </TooltipProvider>
  );
};
